export default {
  tenders: {
    apiErrorTitle: 'Произошла ошибка при обработке запроса',
    allowedApiUrls: [
      // {siteURL}/profile/tenders/{tenderUid}/make-offer
      // {siteURL}/profile/tenders/{tenderId}/make-offer/{offerId}
      '/api/purchase-tenders/private/v1/tender/view_detail-info',
      '/api/purchase-tenders/v1/items-position-offer',
      // '/api/purchase-tenders/v1/value-fields', // в форме постоянно спамится запрос и часто падает
      '/api/purchase-tenders/private/v1/offer/do_publish', // будет после обновления работы с формой подачи
      '/api/purchase-tenders/private/v2/offer', // будет после обновления работы с формой подачи
      '/api/purchase-tenders/private/v1/offer',
      '/api/purchase-tenders/v1/save_document',
      '/api/purchase-tenders/v1/my-file',
      '/api/purchase-tenders/private/v1/bid/view_vat-list',
    ],
  },
}
